import { Provider as ReduxProvider } from 'react-redux';
import { Router } from 'react-router';
import { IntlProvider } from 'react-intl';
import WixSDK from 'shared/utils/wix-sdk';

import { translations } from 'i18n/translations';


export default class Root extends React.Component {
  static propTypes = {
    history: React.PropTypes.object.isRequired,
    routes: React.PropTypes.element.isRequired,
    store: React.PropTypes.object.isRequired,
  };

  render() {
    const { history, routes } = this.props;

    return (
      <ReduxProvider store={this.props.store}>
        <IntlProvider messages={translations}
                      locale={WixSDK.Utils.getLocale()}>
          <Router history={history}>
            {routes}
          </Router>
        </IntlProvider>
      </ReduxProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/root.js